"use client"

import { shutdown, Intercom as IntercomClient, update } from "@intercom/messenger-js-sdk";
import { InitType } from "@intercom/messenger-js-sdk/dist/types";
import { usePathname } from "next/navigation";
import { useEffect } from "react";


const APP_ID = "c1sbgle1";

export function Intercom(props: Partial<InitType>) {
    
    const pathname = usePathname()
    
    IntercomClient({
        // Intercom values
        app_id: APP_ID,
        page_title: 'Archie',
        ...props,
      })

      useEffect(() => {
        // Trigger Intercom update on page change
        update({last_request_at: (new Date()).getTime()/1000})
      }, [pathname])

      return null
}